export default __webpack_public_path__ + "static/media/box-2Open.c234c202.jpg";